// Import manually here to prevent dependency cycle with utils.
import { v4 as uuidv4 } from 'uuid';

import genModel, { FieldSerialization } from '../services/genModel';

export class Image extends genModel({ // eslint-disable-line import/prefer-default-export
  id: { default: '', type: 'string' },
  primary: { default: false, type: 'bool' },
  url: { default: '', type: 'string', optional: true },
  dataUrl: { default: '', type: 'string', optional: true, serialization: FieldSerialization.NEVER },
  blob: {
    default: null,
    type: 'model',
    model: Blob,
    optional: true,
    serialization: FieldSerialization.NEVER
  }
}) {
  static fromJSON(json) {
    if (typeof json === 'string') {
      return new Image({ url: json, id: uuidv4() });
    }

    return new Image(Image.parseJSON(json));
  }
}
